import Vue from "vue";

export async function fetchUser({ commit }, id) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/users/user?id=${id}`
    });
    commit("user/setUser", data.data, { root: true });
  } catch (e) {
    commit("usersError", e.message);
  } finally {
    // console.log("La petición para obtener el usuario ha finalizado");
  }
}

export async function fetchCurrentUser({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/users/current_user_vue?view_as=${full_legal_number}`
    });
    commit("user/setCurrentUser", data, {
      root: true
    });
  } catch (e) {
    commit("usersError", e.message);
  } finally {
    // console.log("La petición para obtener el current user ha finalizado");
  }
}

export async function fetchCurrentUserParents({ commit }, rut) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/users/parents_data?view_as=${rut}`
    });
    commit("user/setCurrentUserParents", data.data, {
      root: true
    });
  } catch (e) {
    commit("usersError", e.message);
  } finally {
    // console.log("La petición para obtener los parents del user ha finalizado");
  }
}

export async function fetchViewAsUser({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/users/user?view_as=${full_legal_number}`
    });
    commit("user/setViewAsUser", data, {
      root: true
    });
  } catch (e) {
    commit("usersError", e.message);
  } finally {
    // console.log("La petición para obtener el selectedUser ha finalizado ");
  }
}

export async function fetchUserMessages({ commit }, ln_user) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/user_messages?view_as=${ln_user}`
    });
    commit("user/setUserMessages", data, { root: true });
  } catch (e) {
    commit("usersError", e.message);
  } finally {
    // console.log("La petición para obtener los mensajes del usuario ha finalizado");
  }
}

export async function hideMessage({ commit }, data) {
  try {
    await Vue.axios({
      method: "POST",
      url: `/frontend/user_message/update`,
      data: data
    });
  } catch (e) {
    commit("usersError", e.message);
  } finally {
    // console.log("La petición para eliminar el mensaje del usuario ha finalizado");
  }
}

export async function showHideCompanyChart({ commit }) {
  commit("setCompanyChart");
}

export async function hideCompanyChart({ commit }) {
  commit("resetCompanyChart", false);
}

export async function showCompanyChart({ commit }) {
  commit("seeCompanyChart", true);
}